import React, { useState, useEffect } from "react";
import Header from "../../components/Header";
import PopupCard, { PopupCardName } from "../../components/PopupCard";
import { useNavigate } from "react-router-dom";
import "./CongThucPage.css";
import axios from "axios";
import SocialButton from "components/SocialButton";
const Cookies = require("js-cookie");

const CongThucPage: React.FC = () => {
  const navigate = useNavigate();
  const [showModal, setShowModal] = useState(false);
  const [selectedFormula, setSelectedFormula] = useState<{
    id: number;
    name: string;
  } | null>(null);
  const [popup, setPopup] = useState<{
    name: PopupCardName;
    status?: "success" | "failed";
    text: React.ReactNode;
    redirectTo?: string;
  } | null>(null);
  const [userCoins, setUserCoins] = useState(0);
  const token = Cookies.get("access_token");

  useEffect(() => {
    const userInfoRaw = localStorage.getItem("user_info");
    if (userInfoRaw) {
      try {
        const userInfo = JSON.parse(userInfoRaw);
        setUserCoins(userInfo.coins || 0);
        console.log("User coins from localStorage:", userInfo.coins);
      } catch (error) {
        console.error("Error parsing user info:", error);
      }
    }
  }, []);

  useEffect(() => {
    if (!popup?.redirectTo) {
      return;
    }

    const timeoutId = window.setTimeout(() => {
      navigate(popup.redirectTo!);
    }, 500);

    return () => {
      window.clearTimeout(timeoutId);
    };
  }, [navigate, popup]);

  const formulas = [
    { id: 1, name: "VIP 1" },
    { id: 2, name: "VIP 2" },
    { id: 3, name: "VIP 3" },
    { id: 4, name: "VIP 4" },
    { id: 5, name: "VIP 5" },
    { id: 6, name: "VIP 6" },
    { id: 7, name: "VIP 7" },
    { id: 8, name: "VIP 8" },
    { id: 9, name: "VIP 9" },
  ];

  const handleFormulaClick = (formula: { id: number; name: string }) => {
    // Tất cả đều hiển thị modal xác nhận
    setSelectedFormula(formula);
    setShowModal(true);
  };

  const getFormulaText = (id: number) => {
    switch (id) {
      case 1:
        return "THỦ THUẬT LV1: MIỄN PHÍ";
      case 2:
        return "THỦ THUẬT LV2: 200 XU";
      case 3:
        return "THỦ THUẬT LV3: 300 XU";
      case 4:
        return "THỦ THUẬT LV4: 400 XU";
      case 5:
        return "THỦ THUẬT LV5: 500 XU";
      case 6:
        return "THỦ THUẬT LV6: 600 XU";
      case 7:
        return "THỦ THUẬT LV7: 700 XU";
      case 8:
        return "THỦ THUẬT LV8: 800 XU";
      case 9:
        return "THỦ THUẬT LV9: 900 XU";
      default:
        return "THỦ THUẬT LV1: MIỄN PHÍ";
    }
  };

  const getFormulaCost = (id: number) => {
    switch (id) {
      case 1:
        return 0; // MIỄN PHÍ
      case 2:
        return 200;
      case 3:
        return 300;
      case 4:
        return 400;
      case 5:
        return 500;
      case 6:
        return 600;
      case 7:
        return 700;
      case 8:
        return 800;
      case 9:
        return 900;
      default:
        return 0;
    }
  };

  const handleConfirm = async () => {
    if (!selectedFormula) return;

    const cost = getFormulaCost(selectedFormula.id);

    // Nếu miễn phí thì đi thẳng
    if (cost === 0) {
      setShowModal(false);
      navigate(`/cong-thuc/${selectedFormula.id}`);
      return;
    }

    // Kiểm tra token trước
    if (!token) {
      showErrorModal("Bạn cần đăng nhập để mua công thức");
      return;
    }

    // Kiểm tra đủ xu không
    if (userCoins < cost) {
      showErrorModal("Bạn không đủ xu, vui lòng nạp thêm hoặc liên hệ admin");
      return;
    }

    try {
      console.log("Calling API with:", {
        amount: cost,
        action: "PLAY_GAME",
      });

      // Gọi API trừ xu
      const response = await axios.post(
        `${process.env.REACT_APP_URL_API}/users/subtract-coins-for-action`,
        {
          amount: cost,
          action: "PLAY_GAME", // Sử dụng action giống như LobbyRoom
        },
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        },
      );

      // Cập nhật số xu
      setUserCoins(response.data.coins);

      // Cập nhật localStorage
      const userInfoRaw = localStorage.getItem("user_info");
      if (userInfoRaw) {
        const userInfo = JSON.parse(userInfoRaw);
        userInfo.coins = response.data.coins;
        localStorage.setItem("user_info", JSON.stringify(userInfo));
      }

      setShowModal(false);
      setPopup({
        name: PopupCardName.Notice,
        status: "success",
        text: `Đã mua ${selectedFormula.name} với giá ${cost} xu`,
        redirectTo: `/cong-thuc/${selectedFormula.id}`,
      });
    } catch (error: any) {
      console.error("Error purchasing formula:", error);
      console.error("Error response:", error.response?.data);
      console.error("Error status:", error.response?.status);

      // Kiểm tra loại lỗi
      if (error.response?.status === 401) {
        showErrorModal("Phiên đăng nhập đã hết hạn, vui lòng đăng nhập lại");
      } else if (error.response?.status === 400) {
        showErrorModal("Bạn không đủ xu, vui lòng nạp thêm hoặc liên hệ admin");
      } else {
        showErrorModal("Có lỗi xảy ra, vui lòng thử lại sau");
      }
    }
  };

  const showErrorModal = (message: string) => {
    setShowModal(false);
    setPopup({
      name: PopupCardName.Notice,
      status: "failed",
      text: message,
    });
  };

  return (
    <div className="cong-thuc-page">
      <Header />
      <div className="w-full h-20 hidden md:block" />
      <div className="cong-thuc-content">
        {/* Logo lớn giống header */}
        {/* <div className="">
          <img src="/assets/logo.png" alt="Logo" className="main-logo" />
        </div> */}

        {/* Nút back */}
        <div className="w-full flex justify-start md:mb-6 mb-3">
          <img
            src="/assets/common/btn-back.png"
            alt="Back"
            className="back-button"
            onClick={() => navigate("/")}
          />
        </div>

        {/* Grid 9 công thức */}
        <div className="formulas-grid">
          {formulas.map((formula) => (
            <div
              key={formula.id}
              className="formula-item"
              onClick={() => handleFormulaClick(formula)}
            >
              <img
                src={`/assets/vip${formula.id}.png`}
                alt={`Công thức ${formula.name}`}
                className="formula-image"
              />
            </div>
          ))}
        </div>
      </div>

      {/* Modal */}
      {showModal && selectedFormula && (
        <PopupCard
          name={PopupCardName.CoinConfirm}
          text={getFormulaText(selectedFormula.id)}
          onConfirm={handleConfirm}
          onClose={() => setShowModal(false)}
        />
      )}

      {popup && (
        <PopupCard
          name={popup.name}
          status={popup.status}
          text={popup.text}
          onClose={() => setPopup(null)}
        />
      )}
      {/* LEFT BTN */}
      <div className="hidden md:block fixed bottom-28 left-14">
        <SocialButton />
      </div>
    </div>
  );
};

export default CongThucPage;
